import cn from 'classnames/bind';

export const classNames = styles => cn.bind(styles);
